// snake_case --> Snake Case
export const capitalizeWord = (word: string): string => {
  if (word.length) {
    return word[0].toUpperCase() + word.slice(1);
  }
  return word;
};
const toCapitalCase = (s: string): string =>
  s.split('_').map(capitalizeWord).join(' ');

export default toCapitalCase;
